module.exports = __webpack_public_path__ + "static/media/date.35c1e0e9.svg";